var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pr-wrapper"},[_c('div',{staticClass:"pr-box"},[_c('div',{staticClass:"pr-header"},[_vm._t("header")],2),_c('div',{staticClass:"pr-pane"},[_vm._t("content")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }